import { useStats } from "@/hooks/useData";

const TRUST = [
  "80+ Vetted Factory Partners",
  "Whole-Home Sourcing",
  "Pre-Shipment Inspection",
  "Global Delivery Support",
  "Custom Cabinetry",
  "Concierge Service",
];

export const StatsBar = () => {
  const { data: stats } = useStats();
  const items = [
    { v: `${stats?.factory_partners ?? 80}+`, l: "Factory Partners" },
    { v: `${stats?.projects_completed ?? 120}+`, l: "Projects Completed" },
    { v: `${stats?.countries_served ?? 14}+`, l: "Countries Served" },
    { v: `${stats?.client_satisfaction ?? 98}%`, l: "Client Satisfaction" },
  ];
  return (
    <section data-testid="stats-bar">
      <div className="border-y border-[#ECEAE4] overflow-hidden py-4 bg-[#F6F5F2]">
        <div className="flex w-max animate-marquee">
          {[...TRUST, ...TRUST].map((t, i) => (
            <span key={i} className="label-eyebrow text-[11px] text-[#5E5A54] mx-8 flex items-center gap-8">
              {t} <span className="text-[#9E8773]">✦</span>
            </span>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-[#ECEAE4]">
          {items.map((s) => (
            <div key={s.l} className="text-center lg:text-left py-8 lg:py-2 lg:px-8 lg:first:pl-0 border-b lg:border-b-0 lg:border-r last:border-r-0 [&:nth-child(2)]:border-r-0 lg:[&:nth-child(2)]:border-r border-[#ECEAE4]" data-testid={`stat-${s.l.toLowerCase().replace(/ /g, "-")}`}>
              <div className="font-display text-5xl sm:text-6xl font-medium text-[#2C2A29] leading-none">{s.v}</div>
              <div className="label-eyebrow text-[10px] text-[#9E8773] mt-3">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
